import { NEW_NOTES_RETRIEVED } from '../types';
import Api from '../../api/Api.js';
import NotesEndpoints from '../../api/NotesEndpoints';

export const getNotes = (bind, bind_id) => ((dispatch) => {
    Api.get(NotesEndpoints.retrieve, { bind, bind_id })
    .then(({ data }) => {
        if(data.length > 0) {
            data.sort((a, b) => {
                if(a.when > b.when)
                    return -1;
                if(a.when < b.when)
                    return 1;

                return 0;
            })
        }

        dispatch({  
            type: NEW_NOTES_RETRIEVED,
            bind,
            id: bind_id,
            payload: data
        })
    })
});
